export const ENUM_VERSIONS_LIST = "ENUM_VERSIONS_LIST"
export const ENUM_VERSIONS_LIST_SUCCESS = "ENUM_VERSIONS_LIST_SUCCESS"
export const ENUM_VERSIONS_LIST_ERROR = "ENUM_VERSIONS_LIST_ERROR"
